import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from 'antd';
import useConnectionContext from '@hooks/useConnectionContext';
import request from '@api';
import classes from './index.module.css';
import Loading from './Loading';

const TITLE = 'Resolve products issues and mishaps through simple replacements and repairs';
const descMap = ['Extended peace of mind for you and your customers', 'Turn bad experience into brand advocates', 'Generate effortless extra profits'];
const footerText = '*After submission, our Account Manager will contact you for the detailed plan for your store.';

export default function Intro() {
  const { merchantId } = useConnectionContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async () => {
    setLoading(true);
    try {
      const { code, message } = await request('open-platform-onboarding', {
        method: 'POST',
        body: {
          merchantId,
          extendedWarrantyOnboardingForm: {},
        },
      });
      if (code === 0) {
        console.log('submit success');
        navigate('./feedback');
      } else {
        navigate('./error', { state: { message } });
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  if (loading) {
    return <Loading />;
  }
  return (
    <div className={classes.intro}>
      <div className={classes.title}>
        {TITLE}
      </div>
      <ul className={classes.desc}>
        {descMap.map((desc) => <li key={desc} className={classes.desc_item}>{desc}</li>)}
      </ul>

      <Button
        type="primary"
        className={classes.next_button}
        onClick={onSubmit}
        loading={loading}
        htmlType="submit"
      >
        Apply now
      </Button>

      <div className={classes.footer}>{footerText}</div>

    </div>

  );
}
